import React, { useState } from "react";
import PropTypes from "prop-types";
import { isFunction, isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";
import Modal from "@cayuse/shared-react.components.modal";
import RuleConditionSelector from "components/RuleConditionSelector";
import Button from "@cayuse/shared-react.components.button";

import styles from "./styles.css";

const RuleConditionSelectorModal = ({
	dictionary,
	open,
	onClose,
	onRuleChange,
	onCancel,
	onUpdate,
	formSections, // todo: get from redux?
	formElements,
	rule,
	...rest
}) => {
	const [ selectedValue, setSelectedValue ] = useState(rule.optionId);
	const isUpdateEnabled = isNonEmptyString(selectedValue);

	const handleOnClose = () => {
		if (isFunction(onClose)) {
			onClose();
		}
	};

	const handleRuleChange = newValue => {
		setSelectedValue(newValue);

		if (isFunction(onRuleChange)) { // todo: not sure we need to do anything here, updating selectedValue may suffice
			onRuleChange(newValue);
		}
	};

	const handleOnCancel = () => {
		if (isFunction(onCancel)) {
			onCancel();
		}
	};

	const handleOnUpdate = () => {
		const [ formElementId, optionId ] = isNonEmptyString(selectedValue)
			? selectedValue.split("#")
			: [];

		if (isFunction(onUpdate)) {
			onUpdate({ optionId, formElementId });
		}
	};

	return (
		<Modal closeIcon
		       closeOnEscape={true}
		       onClose={handleOnClose}
		       trigger={null}
		       open={open}
			   className={styles.ruleConditionSelectorModal}
			   ariaLabel={dictionary.addCondition || "Add Condition"}
		>
			<Modal.Header className="ui header whiteOnBlue">
				<h2>{dictionary.addCondition || "Add Condition"}</h2>
			</Modal.Header>

			<Modal.Content>
				<RuleConditionSelector
					onRuleChange={handleRuleChange}
					option={rule}
					formSections={formSections}
					formElements={formElements}
					{...rest}
				/>
			</Modal.Content>

			<Modal.Actions>
				<Button secondary onClick={handleOnCancel}>
					{dictionary.cancelModal || "Cancel"}
				</Button>
				<Button primary onClick={handleOnUpdate} disabled={!isUpdateEnabled}>
					{dictionary.updateModal || "Update"}
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

RuleConditionSelectorModal.propTypes = {
	dictionary: PropTypes.object,
	open: PropTypes.bool,
	onClose: PropTypes.func,
	onRuleChange: PropTypes.func,
	onCancel: PropTypes.func,
	onUpdate: PropTypes.func,
	formSections: PropTypes.object,
	formElements: PropTypes.array,
	rule: PropTypes.shape({
		ruleType: PropTypes.string,
		optionId: PropTypes.string
	})
};

export default RuleConditionSelectorModal;
